module.exports = __webpack_public_path__ + "928db693030bd7da498458b2ac443878.pdf";